import { CustomSxProps, UI_KIT } from "../../theme";

export const favoriteMovie__title: CustomSxProps = {
	paddingBottom: UI_KIT.p8,
};

export const favoriteMovieWrap: CustomSxProps = {
	border: "1px sold black",
	padding: UI_KIT.p8,
};
